// src/pages/LegalMentions/LegalMentions.js
import React from 'react';
import styles from './LegalMentions.module.css';

const LegalMentions = () => {
  return (
    <div className={styles.legalPage}>
      <div className={styles.container}>
        <h1 className={styles.pageTitle}>MENTIONS LÉGALES</h1>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Informations Légales de l'Éditeur du Site (Le Poke)</h2>
          <p><strong>Nom de l'établissement :</strong> LE POKE</p>
          <p><strong>Forme juridique :</strong> SAS, société par actions simplifiée</p>
          <p><strong>Siège social / Adresse :</strong> 15 PLACE DU 8 MAI 1945 32130 SAMATAN, France</p>
          <p><strong>Téléphone :</strong> 06.98.01.25.29</p>
          <p><strong>E-mail :</strong> contact@le-poke.com</p>
          <p><strong>Numéro SIRET :</strong> 898 416 375 00019</p>
          <p><strong>Directeur de la publication :</strong> Infocolab</p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Hébergement du Site</h2>
          <p><strong>Nom de l'hébergeur :</strong> LWS</p>
          <p><strong>Adresse de l'hébergeur :</strong> 10, RUE PENTHIEVRE 75008 PARIS, France</p>
          <p><strong>Numéro de téléphone de l'hébergeur :</strong> 01 77 62 30 03</p>
          <p><strong>Site web de l'hébergeur :</strong> <a href="https://www.lws.fr" target="_blank" rel="noopener noreferrer">www.lws.fr</a></p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Propriété Intellectuelle</h2>
          <p>Le Poke est propriétaire des droits de propriété intellectuelle et détient les droits d’usage sur tous les éléments accessibles sur le site internet "Le Poke", notamment les textes, images, graphismes, logos, vidéos, icônes et sons.</p>
          <p>Toute reproduction, représentation, modification, publication, adaptation de tout ou partie des éléments du site, quel que soit le moyen ou le procédé utilisé, est interdite, sauf autorisation écrite préalable de Le Poke.</p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Responsabilité</h2>
          <p>Le Poke ne pourra être tenu pour responsable des dommages directs et indirects causés au matériel de l’utilisateur, lors de l’accès au site internet Le Poke.</p>
          <p>Le Poke décline toute responsabilité quant à l’utilisation qui pourrait être faite des informations et contenus présents sur le site Le Poke.</p>
        </section>

        <section className={styles.section}>
          <h2 className={styles.sectionHeading}>Droit Applicable et Attribution de Juridiction</h2>
          <p>Tout litige en relation avec l’utilisation du site Le Poke est soumis au droit français. En dehors des cas où la loi ne le permet pas, il est fait attribution exclusive de juridiction aux tribunaux compétents de la ville de Toulouse (si le siège social est à Samatan, c'est généralement le tribunal le plus proche qui est pertinent pour les entreprises).</p>
          <p>Il est recommandé de consulter un professionnel du droit pour confirmer la juridiction compétente exacte.</p>
        </section>
        
      </div>
    </div>
  );
};

export default LegalMentions;